<template>
	<div>
		<div class="time-input">
			<select v-model="form.hour" class="form-control">
				<option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
			</select>
			:
			<select v-model="form.minute" class="form-control">
				<option value="00">00</option>
				<option value="30">30</option>
			</select>
		</div>
	</div>
</template>


<script>
export default {
	data() {
		return {
			form: {
				hour: '00', // Начальное значение для часов
				minute: '00', // Начальное значение для минут
			},
			hours: this.generateHours(),
		};
	},
	methods: {
		generateHours() {
			const hours = [];
			for (let i = 0; i < 24; i++) {
				hours.push(this.pad(i));
			}
			return hours;
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number; // Добавляем ведущий ноль
		},
	},
	computed: {
		time() {
			return `${this.form.hour}:${this.form.minute}`; // Форматируем время для отображения
		},
	},
	watch: {
		time(newTime) {
			this.$emit('update:time', newTime); // Эмитируем событие с новым временем
		},
	},
};
</script>

<style scoped>
.time-input {
	display: flex;
	align-items: center;
}
.form-control {
	margin: 0 5px;
}
</style>